// Action creators
import { readJson } from './apiResponse';

// GET logged in user's profile, runs immediately when the App component mounts

var getProfileFetch = () => {
    return dispatch => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/user/me", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(resp => readJson(resp, "api/user/me"))
                .then(data => {
                    // null means the token was rejected; readJson already cleared it.
                    if (!data) {
                        return;
                    }
                    if (data.message) {
                        localStorage.removeItem("token")
                    } else {
                        dispatch(loginUser(data))
                    }
                })
                .catch(err => console.error("getProfileFetch failed:", err))
        }
    }
}

// options.keepalive is for App.unload, which posts the "Done" status as the
// page closes. A plain fetch started from beforeunload is cancelled along
// with the page, so the user could stay "Available" after leaving; keepalive
// lets the request finish on its own.
var updateProfile = (user, options = {}) => {
    return dispatch => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/user/update", {
                method: "POST",
                keepalive: !!options.keepalive,
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(user)
            })
                .then(resp => readJson(resp, "api/user/update"))
                .then(data => {
                    if (!data) {
                        return null;
                    }
                    if (data.message) {
                        localStorage.removeItem("token")
                        return null;
                    }
                    // A rejected update answers 400 with a JSON body of its own -
                    // {"password":["..."]} from model validation, or
                    // {"email":"No user with this email"}. PROFILE_LOAD replaces the
                    // profile wholesale, so dispatching one of those would swap the
                    // signed-in user for an error object and take everything reading
                    // profile.id down with it, including the hub's activity ping.
                    if (!data.id) {
                        console.error("api/user/update rejected the update:", data);
                        return null;
                    }
                    dispatch(loginUser(data))
                    return data;
                })
                .catch(err => {
                    console.error("updateProfile failed:", err);
                    return null;
                })
        }
        // Callers may chain on the result, so a signed-out call resolves too.
        return Promise.resolve(null);
    }
}

const loginUser = userObj => ({
    type: 'PROFILE_LOAD',
    payload: userObj
})

export default { 'LOAD_PROFILE': getProfileFetch, 'UPDATE_PROFILE': updateProfile };


// WEBPACK FOOTER //
// ./src/actions/profile_actions.js


// WEBPACK FOOTER //
// ./src/actions/profile_actions.js